import { Action, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { articoloBE } from '../models/sync.model';
import { InitCatalogo, SetCatalogo } from './catalogo.actions';
import { liveQuery } from 'dexie';
import { db } from 'src/app/db';
export interface CatalogoStateModel {
  articoli: Array<articoloBE>|null;
  loading: boolean;
}

@State<CatalogoStateModel>({
  name: 'catalogo',
  defaults: {
    articoli: null,
    loading: false,
  }
})
@Injectable()
export class CatalogoState {
  @Action(InitCatalogo)
  init(ctx: StateContext<CatalogoStateModel>, action: InitCatalogo) {

    const st = ctx.getState();
   
    if (!st.articoli && st.loading===false) {
      const $articoli = liveQuery(() => db.articoli.toArray());
      let arts = [];
      ctx.setState({
        articoli: null, loading : true
      });
      $articoli.subscribe({
        next: (articles) => {
            arts = articles;
            ctx.setState({
              articoli: arts, loading : false
            });
        }
      });
    }

  }

  @Action(SetCatalogo)
  set(ctx: StateContext<CatalogoStateModel>, action: SetCatalogo) {
    ctx.setState({
      articoli:  action.articoli,
      loading: false
    });
  }

}
